import { useEffect, useState } from 'react';

import { CustomSelect } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../../../common/CustomIcons';
import CustomSelectAll from '../../../common/CustomSelect';

import './styles/index.css';

const AccountCascadingRow = ({ soldTo, regSoldTos, soldToIndex, userAccAssocLabels, deleteRow, onSelection }) => {
  const initialize = (options = []) => {
    const validList = options.filter(shipTo => shipTo.label);
    return validList.length ? validList.every(shipTo => shipTo.selected) : false;
  };
  const [soldToDrpdwn, setSoldToDrpdwn] = useState([]);
  const [shipToDrpdwn, setShipToDrpdwn] = useState([]);
  const [salesAreaDrpdwn, setSalesAreaDrpdwn] = useState([]);
  const [currentSoldTo, setCurrentSoldTo] = useState(soldTo);
  const [selectAll, setSelectAll] = useState(initialize(soldTo.shipTos));
  const [selectAllBzUnit, setSelectAllBzUnit] = useState(false);

  const setSalesAreaAllStatus = salesAreaOptions => {
    const isAll = salesAreaOptions.every(item => item.selected);
    if (isAll) {
      setSelectAllBzUnit(true);
    }
  };

  const sortByLabel = array => array.sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    if (soldTo.shipTos) {
      const salesAreaDropdown = [];
      soldTo.shipTos.map(shipTo => {
        if (shipTo.selected && shipTo.label) {
          shipTo.salesArea.map(salesArea => {
            const found = salesAreaDropdown.some(sales => sales.id === salesArea.id);
            if (!found) {
              salesAreaDropdown.push(salesArea);
            }
            return salesArea;
          });
        }
        return shipTo;
      });

      const sortedSalesAreaDropdown = sortByLabel(salesAreaDropdown);
      setSalesAreaAllStatus(sortedSalesAreaDropdown);
      setShipToDrpdwn(soldTo.shipTos);
      setSalesAreaDrpdwn(sortedSalesAreaDropdown);
    }
    setSoldToDrpdwn(regSoldTos);
  }, [soldTo, regSoldTos]);

  const multi = (options, selectionStatus) => {
    if (options.length) {
      const { selectAll: selectAllLabel = 'Select All' } = userAccAssocLabels;
      return [{ label: selectAllLabel, id: 0, value: 'Select All', isSelected: !!selectionStatus }].concat(options);
    }
    return options;
  };

  const soldToSelectionHandler = (currentSelection, index) => {
    let updatedSoldTo = currentSelection;
    updatedSoldTo = {
      ...currentSelection,
      selected: true,
      shipTos: updatedSoldTo.shipTos.map(shipTo => {
        if (shipTo.selected) {
          return {
            ...shipTo,
            selected: false,
            salesArea: shipTo.salesArea.map(salesArea => {
              if (salesArea.selected) {
                const sales = { ...salesArea };
                sales.selected = false;
                return sales;
              }
              return salesArea;
            })
          };
        }
        return shipTo;
      })
    };
    setCurrentSoldTo(updatedSoldTo);
    setSelectAll(false);
    onSelection(updatedSoldTo, index);
  };

  const shipToSelectionHandler = (currentSelections, index) => {
    let updatedSoldTo = {};
    let count = 0;
    const currentFolded = currentSelections.find(item => item.id === 0);
    if (currentFolded && currentFolded.value === 'Select All') {
      updatedSoldTo = {
        ...currentSoldTo,
        shipTos: currentSoldTo.shipTos.map(shipTo => {
          const temp = { ...shipTo };
          temp.selected = shipTo.label && !selectAll;
          return {
            ...temp,
            salesArea: temp.salesArea.map(salesArea => {
              const sales = { ...salesArea };
              sales.selected = false;
              return sales;
            })
          };
        })
      };
      setSelectAll(!selectAll);
    } else {
      updatedSoldTo = {
        ...currentSoldTo,
        shipTos: currentSoldTo.shipTos.map(shipTo => {
          const temp = { ...shipTo };
          temp.selected = false;
          if (!shipTo.label) count += 1;
          currentSelections.map(selectedShipTo => {
            if (shipTo.id === selectedShipTo.id) {
              temp.selected = true;
            }
            return temp;
          });
          return {
            ...temp,
            salesArea: temp.salesArea.map(salesArea => {
              if (salesArea.selected) {
                const sales = { ...salesArea };
                sales.selected = false;
                return sales;
              }
              return salesArea;
            })
          };
        })
      };
      if (currentSelections.length + count < currentSoldTo.shipTos.length) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
    }
    setSelectAllBzUnit(false);
    setCurrentSoldTo(updatedSoldTo);
    onSelection(updatedSoldTo, index);
  };

  const salesAreaSelectionHandler = (currentSelections, index) => {
    let updatedSoldTo = {};
    const currentFolded = currentSelections.find(item => item.id === 0);
    if (currentFolded && currentFolded.value === 'Select All') {
      updatedSoldTo = {
        ...currentSoldTo,
        shipTos: currentSoldTo.shipTos.map(shipTo => ({
          ...shipTo,
          salesArea: shipTo.salesArea.map(salesArea => ({ ...salesArea, selected: !selectAllBzUnit }))
        }))
      };
      setSelectAllBzUnit(!selectAllBzUnit);
    } else {
      updatedSoldTo = {
        ...currentSoldTo,
        shipTos: currentSoldTo.shipTos.map(shipTo => {
          if (shipTo.selected) {
            return {
              ...shipTo,
              salesArea: shipTo.salesArea.map(sales => {
                const temp = { ...sales };
                temp.selected = false;
                currentSelections.forEach(selectedSales => {
                  if (sales.value === selectedSales.value) {
                    temp.selected = true;
                  }
                });
                return temp;
              })
            };
          }
          return shipTo;
        })
      };
      if (currentSelections.length < salesAreaDrpdwn.length) {
        setSelectAllBzUnit(false);
      } else {
        setSelectAllBzUnit(true);
      }
    }
    setCurrentSoldTo(updatedSoldTo);
    onSelection(updatedSoldTo, index);
  };

  const deleteRowHandler = index => {
    let updatedSoldTo = {};
    if (currentSoldTo.shipTos) {
      updatedSoldTo = {
        ...currentSoldTo,
        selected: false,
        shipTos: currentSoldTo.shipTos.map(shipTo => ({
          ...shipTo,
          selected: false,
          salesArea: shipTo.salesArea.map(salesArea => {
            const sales = { ...salesArea };
            sales.selected = false;
            return sales;
          })
        }))
      };
    }
    setCurrentSoldTo(updatedSoldTo);
    deleteRow(index);
  };

  const renderCustomSelectAll = (selectAllStatus, options, changeHandler, selectLabel, classes, classPrefix) => (
    <div className={`dropdown-wrap${selectAllStatus ? ' select-all' : ''}`}>
      <CustomSelectAll
        classes={classes}
        classNamePrefix={classPrefix}
        selectLabel={selectLabel}
        isSearchable
        options={multi(options, selectAllStatus)}
        getOptionLabel={option =>
          option.label !== option.value && option.value !== 'Select All'
            ? `${option.label} |
          ${option.value}`
            : option.label
        }
        value={options.filter(s => s.selected)}
        isOptionDisabled={option => classPrefix === 'shipto' && !option.label}
        isMulti
        withCheckBox
        customLabelDisplay
        closeMenuOnSelect={false}
        allowSelectAll
        onChange={value => changeHandler(value, soldToIndex)}
      />
    </div>
  );

  return (
    <div className="account-row zeta" key={`${soldToIndex}-${soldTo.value}`} id={`account-${soldToIndex}`}>
      <div className="dropdown-wrap">
        <CustomSelect
          classes="soldto-select"
          classNamePrefix="soldto"
          selectLabel={userAccAssocLabels.soldTo}
          isSearchable
          options={soldToDrpdwn}
          isOptionDisabled={option => !option.label}
          getOptionLabel={option => `${option.label} |
              ${option.value}`}
          value={Object.keys(soldTo).length ? [soldTo] : []}
          onChange={currentSelection => soldToSelectionHandler(currentSelection, soldToIndex)}
        />
      </div>
      {renderCustomSelectAll(
        selectAll,
        shipToDrpdwn,
        shipToSelectionHandler,
        userAccAssocLabels.shipTo,
        'shipto-select',
        'shipto'
      )}
      {renderCustomSelectAll(
        selectAllBzUnit,
        salesAreaDrpdwn,
        salesAreaSelectionHandler,
        userAccAssocLabels.businessUnit,
        'bzUnit-select',
        'bzUnit'
      )}
      <div
        className="delete-btn-wrap"
        onClick={() => deleteRowHandler(soldToIndex)}
        onKeyUp={() => deleteRowHandler(soldToIndex)}
        role="presentation"
      >
        <CustomIcon type="circleClose" className="deleteBtn" size="24" />
      </div>
    </div>
  );
};

AccountCascadingRow.propTypes = {
  soldTo: PropTypes.instanceOf(Object),
  soldToIndex: PropTypes.number,
  regSoldTos: PropTypes.instanceOf(Array),
  userAccAssocLabels: PropTypes.shape({
    soldTo: PropTypes.string,
    shipTo: PropTypes.string,
    businessUnit: PropTypes.string,
    selectAll: PropTypes.string
  }).isRequired,
  deleteRow: PropTypes.func,
  onSelection: PropTypes.func
};

AccountCascadingRow.defaultProps = {
  soldTo: {},
  soldToIndex: 0,
  regSoldTos: [],
  deleteRow: () => {},
  onSelection: () => {}
};

export default AccountCascadingRow;
